import { useSelector } from 'react-redux';
import Link from 'next/link';

import MenuLogo from '@r1-frontend/entities/Layout/_deps/components/MenuLogo';
import { getCurrentCity } from '@r1-frontend/entities/stores/city/selectors';

import * as ST from './styled';


export const Logo = () => {
    const city = useSelector(getCurrentCity);

    return <ST.Logo>
        <Link href='/' passHref>
            <MenuLogo href='/' cityData={city}/>
        </Link>
    </ST.Logo>;
};
